// extracted by mini-css-extract-plugin
export default {"markdown":"SimpleMarkdown-module--markdown--90139"};